import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Apis from '../../Apis.js';
import { showAlert } from '../../ui/dialog';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import axios from 'axios';

const Spinner = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" style={{ animation: 'ge-spin 0.8s linear infinite' }}>
    <circle cx="9" cy="9" r="7" fill="none" stroke="#9ca3af" strokeWidth="2" strokeDasharray="22 22" strokeLinecap="round" />
    <style>{`@keyframes ge-spin{to{transform:rotate(360deg);}}`}</style>
  </svg>
);

const DARK = '#1e3a4c';
const DARK_HOVER = '#162e3c';

const inputBase = {
  width: '100%', height: 42, padding: '0 12px',
  border: '1px solid #d1d5db', borderRadius: 4,
  fontSize: 14, fontFamily: 'inherit', color: '#111827',
  background: '#fff', outline: 'none', boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};

const AlterarSenha = () => {
  const navigate = useNavigate();
  const [email, setEmail]             = useState('');
  const [cnpjEmpresa, setCnpjEmpresa] = useState('');
  const [validCpfCnpj, setValidCpfCnpj] = useState();
  const [loading, setLoading]         = useState(false);

  useEffect(() => {
    if (cnpjEmpresa.length >= 11 && cnpjEmpresa.length <= 18) {
      setValidCpfCnpj(cpf.isValid(cnpjEmpresa) || cnpj.isValid(cnpjEmpresa));
    }
  }, [cnpjEmpresa]);

  const alertErr = (msg) => showAlert({ title: 'Atenção', text: msg, icon: 'error', dangerMode: true });

  const handleSubmit = async () => {
    if (validCpfCnpj === false || cnpjEmpresa.length < 11) { alertErr('CPF/CNPJ inválido!'); return; }
    if (!email || !cnpjEmpresa || !validCpfCnpj) { alertErr('Todos os campos devem ser preenchidos!'); return; }
    setLoading(true);
    await axios.post(Apis.urlAlterarSenha, { email, cnpj: cnpjEmpresa }, {
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      if (res.data.retorno.sucesso) {
        navigate(`/alerta-sucesso/${res.data.retorno.mensagem}&login`);
      } else {
        alertErr(res.data.retorno.mensagem);
      }
    }).finally(() => setLoading(false));
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', maxWidth: 1920, margin: '0 auto' }}>

      {/* ── Left panel ── */}
      <div style={{
        flex: 1, background: DARK,
        flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        padding: '48px 56px', position: 'relative', overflow: 'hidden',
        display: window.innerWidth < 900 ? 'none' : 'flex',
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.04,
          backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)',
          backgroundSize: '40px 40px',
        }} />

        <div style={{ position: 'relative', textAlign: 'center' }}>
          <h2 style={{ color: '#fff', fontSize: 32, fontWeight: 700, lineHeight: 1.25, margin: '0 0 16px', letterSpacing: '-0.5px' }}>
            Recupere seu<br />
            <span style={{ color: '#94b8cc' }}>acesso.</span>
          </h2>
          <p style={{ color: '#6b8fa3', fontSize: 14, lineHeight: 1.75, margin: '0 0 40px' }}>
            Informe os dados cadastrados para receber o link de recuperação por e-mail.
          </p>

          {['Processo rápido e seguro', 'Link enviado para seu e-mail', 'Suporte disponível'].map(f => (
            <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 14 }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#3d6a85', flexShrink: 0 }} />
              <span style={{ color: '#8ab0c4', fontSize: 13.5 }}>{f}</span>
            </div>
          ))}
        </div>

        <p style={{ position: 'absolute', bottom: 32, color: '#3d6a85', fontSize: 12, margin: 0 }}>
          © {new Date().getFullYear()} GE Sistemas
        </p>
      </div>

      {/* ── Right form ── */}
      <div style={{
        flex: 1, background: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '48px 40px', boxSizing: 'border-box',
        borderLeft: '1px solid #e5e7eb',
      }}>
        <div style={{ width: '100%', maxWidth: 400 }}>

          <div style={{ marginBottom: 36 }}>
            <h1 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 700, color: '#111827', letterSpacing: '-0.3px' }}>
              Recuperar senha
            </h1>
            <p style={{ margin: 0, fontSize: 13.5, color: '#6b7280' }}>
              Informe o CNPJ e o e-mail cadastrado na sua conta
            </p>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>CNPJ da empresa</label>
            <input
              type="text" placeholder="CNPJ da empresa"
              value={cnpjEmpresa} onChange={e => setCnpjEmpresa(e.target.value)}
              style={{
                ...inputBase,
                borderColor: validCpfCnpj === false ? '#ef4444' : '#d1d5db',
              }}
              onFocus={e => e.target.style.borderColor = DARK}
              onBlur={e => e.target.style.borderColor = validCpfCnpj === false ? '#ef4444' : '#d1d5db'}
            />
            {validCpfCnpj === false && (
              <p style={{ margin: '4px 0 0', fontSize: 12, color: '#ef4444' }}>CPF/CNPJ inválido</p>
            )}
          </div>

          <div style={{ marginBottom: 28 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>E-mail</label>
            <input
              type="email" placeholder="E-mail cadastrado"
              value={email} onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={inputBase}
              onFocus={e => e.target.style.borderColor = DARK}
              onBlur={e => e.target.style.borderColor = '#d1d5db'}
            />
          </div>

          <button onClick={handleSubmit} disabled={loading} style={{
            width: '100%', height: 42, borderRadius: 4, border: 'none',
            background: loading ? '#e5e7eb' : DARK,
            color: loading ? '#9ca3af' : '#fff',
            fontSize: 14, fontWeight: 600, cursor: loading ? 'default' : 'pointer',
            fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'background 0.15s',
          }}
            onMouseEnter={e => { if (!loading) e.currentTarget.style.background = DARK_HOVER; }}
            onMouseLeave={e => { if (!loading) e.currentTarget.style.background = DARK; }}
          >
            {loading ? <Spinner /> : 'Enviar link de recuperação'}
          </button>

          <div style={{ marginTop: 20 }}>
            <button onClick={() => navigate('/login')} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#6b7280', fontSize: 13, fontFamily: 'inherit',
              textDecoration: 'underline', textUnderlineOffset: 3,
            }}>
              Voltar ao login
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AlterarSenha;
